import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UploadOperationFileRequest, Operation, OperationInformation, OperationDocumentGroupByType, OperationAssignDocumentsRead, OperationDocumentUpdateDescription } from "src/app/domain/models/Operation";
import { OperationGateway } from "../gateway/OperationGateWay";
import { Routes } from "src/app/infrastructure/routes";
import { OperationDocument } from "src/app/domain/models/OperationDocument";
import { DocumentStageClear } from "src/app/domain/models/DocumentStageClear";

@Injectable({providedIn: 'root'})
export class OperationService extends OperationGateway{

    constructor(private _http: HttpClient){
        super()
    }

    uploadFile(uploadRequest: UploadOperationFileRequest): Observable<Operation> {
      return this._http.put<Operation>(Routes.operationApi + '/UploadInstructive',
      this.getFormDataCreate(uploadRequest)
      )
    }

    updateDocument(operationDocument: OperationDocument): Observable<OperationDocument> {
      return this._http.put<OperationDocument>(Routes.operationApi + '/UpdateDocument',
        this.getFormDataUpdate(operationDocument)
      )
    }

    deleteDocument(guid: string): Observable<any> {
      return this._http.delete<any>(Routes.operationApi + '/DeleteDocument', { params: {guid}})
    }

    getFormDataCreate(uploadRequest: UploadOperationFileRequest){
        const formData = new FormData();
        formData.append("orderId", uploadRequest.orderId.toString());
        formData.append("name", uploadRequest.name);
        formData.append("pdf", uploadRequest.pdf)
        formData.append("operationDocumentTypeId", uploadRequest.operationDocumentTypeId)
        return formData;
    }

    getFormDataUpdate(operationDocument: OperationDocument) {
      const formData = new FormData();
      formData.append("id", operationDocument.id.toString())
      formData.append("name", operationDocument.name)
      formData.append("pdf", operationDocument.pdf)
      return formData;
    }

    getFormDataCreateMultiple(files: any[], names: string[], documentTypes: number[], orderId: string)
    {
      const formData = new FormData();

        files.forEach(element => {
          formData.append("pdf", element)
        });

        names.forEach(element => {
          formData.append("names[]", element)
        });

        documentTypes.forEach(element => {
            formData.append("operationDocumentTypes[]", element.toString())
        })


        formData.append("orderId", orderId.toString());

        return formData;
    }

    uploadFileMultiple(files: any[], names: string[], documentTypes: number[], orderId: string): Observable<Operation> {
      return this._http.put<Operation>(Routes.operationApi + '/UploadOperationDocumentMultiple',
        this.getFormDataCreateMultiple(files, names, documentTypes, orderId )
      )
    }


    getByImportOrderId(importOrderId: any): Observable<OperationInformation>{
        return this._http.get<OperationInformation>(Routes.operationApi + '/GetOperationDocuments', {params: {importOrderId}})
    }

    getDocumentsByDocumentStage(importOrderId: string, documentStageId: number ): Observable<OperationDocumentGroupByType[]>
    {
      return this._http.get<OperationDocumentGroupByType[]>(Routes.operationApi + '/GetOperationDocumentsByType', {params: {importOrderId, documentStageId}})
    }

    hasPendingViewsStage(operationDocumentTypeId: number,  importOrderId: string):Observable<any>
    {
      return this._http.put(Routes.operationApi + '/ChangeViewDocument',{operationDocumentTypeId, importOrderId})
    }

    updateDescription(documentId: string, documentDescription: string, isForwarderDocument: boolean, isQcDocument: boolean, operationDocumentType?: number): Observable<any> {
      const request: OperationDocumentUpdateDescription = {
        documentId,
        documentDescription,
        isForwarderDocument,
        isQcDocument
      }

      if (operationDocumentType) {
        request.operationDocumentType = operationDocumentType;
      }
      return this._http.put(Routes.operationApi + '/UpdateDocumentDescription',{...request})
    }

    getClearStages(importOrderId: string): Observable<DocumentStageClear>
    {
      return this._http.get<DocumentStageClear>(Routes.operationApi + '/GetClearStages', {params:{importOrderId}})
    }

    assignDocumentsRead(request: OperationAssignDocumentsRead): Observable<any>{
      return this._http.post<any>(Routes.operationApi + '/AssignDocumentsRead', request)
    }

    downloadDocumentAssignmentReport(exporterId: number, startDate: string, endDate: string): Observable<any> {
      const headers = new HttpHeaders({
        'Content-Type': 'application/octet-stream'
      })
      return this._http.get<any>(Routes.operationApi + '/DownloadDocumentAssignmentReport', {params: {exporterId, startDate, endDate}, headers: headers, observe: 'response', responseType: 'blob' as 'json'})
    }
}
